var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "remastered-dialog" },
    [
      _vm._t("before"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wrap",
          class: { blurred: _vm.blurred },
          style: _vm.dialogStyle,
        },
        [
          _c(
            "div",
            { staticClass: "headline" },
            [
              _vm.$scopedSlots.title
                ? _vm._t("title")
                : _c("span", [_vm._v(_vm._s(_vm.title))]),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
        ]
      ),
      _vm._v(" "),
      _vm._t("after"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }